/* @ngInject */
function RichTextInputController ($sce, $timeout) {
  var ctrl = this
  this.hideToolbar = true

  ctrl.$onInit = function () {
    $timeout(function () {
      if (typeof ctrl.field === 'object') {
        ctrl.value = ctrl.field.value
      } else {
        ctrl.value = ctrl.field
      }

      if (angular.isUndefined(ctrl.hideToolbar)) {
        ctrl.hideToolbar = true
      }

      ctrl.formattedValue = $sce.trustAsHtml(ctrl.value)
      if (ctrl.field.rules) {
        ctrl.field.maxlength = parseInt(ctrl.field.rules.filter(function (rule) { return rule.type === 'MAX_LENGTH' }).map(function (rule) { return rule.value })[0]) || undefined
      }
    }, 100)
  }

  ctrl.$onChanges = ctrl.$onInit

  ctrl.handleRichTextEditorInit = function (e, editor) {
    ctrl._richTextEditor = editor
    if (!this.hideToolbar) {
      jQuery(ctrl._richTextEditor.composition.delegate.toolbarController.element).addClass('show')
    }
  }

  ctrl.handleRichTextFieldFocus = function (e, editor) {
    if (this.hideToolbar) {
      jQuery(ctrl._richTextEditor.composition.delegate.toolbarController.element).addClass('show')
    }
  }

  ctrl.handleRichTextFieldBlur = function (e, editor) {
    if (this.hideToolbar && !jQuery(document.activeElement).hasClass('trix-input')) {
      jQuery(ctrl._richTextEditor.composition.delegate.toolbarController.element).removeClass('show')
    }
  }

  ctrl.changeValue = function () {
    if (this.field.maxlength && this.field.maxlength > 0 && ctrl._richTextEditor.getDocument().getLength() > this.field.maxlength) {
      ctrl._richTextEditor.setSelectedRange([this.field.maxlength, ctrl._richTextEditor.getDocument().getLength()])
      ctrl._richTextEditor.insertHTML('')
    }
    this.onChange({ value: this.value })
  }
}

export { RichTextInputController }
